import React from 'react';
import { TabContent, TabPane } from 'reactstrap';
import VendorChart from './components/VendorChart';
import ActiveBidsChart from './components/ActiveBidsChart';
import ListingChart from './components/ListingChart';
import OrderChart from './components/OrderChart';
import TransportationChart from './components/TransportationChart';

const AllCharts = ({ activeTab, selectedOption, permissions }) => {
  return (
    <TabContent activeTab={activeTab}>
      <TabPane tabId={1}>
        <ListingChart
          selectedOption={selectedOption}
          canView={permissions?.listing}
        />
      </TabPane>
      <TabPane tabId={2}>
        <ActiveBidsChart
          selectedOption={selectedOption}
          canView={permissions?.bids}
        />
      </TabPane>
      <TabPane tabId={3}>
        <VendorChart
          selectedOption={selectedOption}
          canView={permissions?.vendors}
        />
      </TabPane>
      <TabPane tabId={4}>
        <OrderChart
          selectedOption={selectedOption}
          canView={permissions?.orders}
        />
      </TabPane>
      <TabPane tabId={5}>
        <TransportationChart selectedOption={selectedOption} />
      </TabPane>
    </TabContent>
  );
};

export default AllCharts;
